import { Dropdown, DefaultDropdownProps } from 'framework/form';
import { OPPORTUNITY_TYPE } from 'domain/sales/opportunity/opportunityService';

const OpportunityTypeDropdown = (props: Omit<DefaultDropdownProps, 'options'>) => {
  return (
    <Dropdown
      options={Object.entries(OPPORTUNITY_TYPE).map(entry => {
        const [value, label] = entry;

        return {
          value,
          label,
        };
      })}
      label="Type"
      {...props}
    />
  );
};

export default OpportunityTypeDropdown;
